import React from "react";
import { GUIBox } from "../GameUIElements";
import styled from "styled-components";
import { SoundSourceDebugUI } from "./SoundSourceDebugUI";
import { SoundInstanceDebugUI } from "./SoundInstanceDebugUI";
const FixedHeightGUIBox = styled(GUIBox).withConfig({
  displayName: "SoundDebugUI__FixedHeightGUIBox",
  componentId: "sc-9dpbyf-0"
})(["height:570px;width:300px;"]);
const FlexRow = styled.div.withConfig({
  displayName: "SoundDebugUI__FlexRow",
  componentId: "sc-9dpbyf-1"
})(["display:flex;flex-direction:column;"]);
const Section = styled.div.withConfig({
  displayName: "SoundDebugUI__Section",
  componentId: "sc-9dpbyf-2"
})(["display:flex;flex-direction:column;margin:2px;"]);
export const SoundDebugInfoUI = () => {
  return /*#__PURE__*/React.createElement(FixedHeightGUIBox, null, /*#__PURE__*/React.createElement(FlexRow, null, /*#__PURE__*/React.createElement(Section, {
    style: {
      flexBasis: "200px"
    }
  }, /*#__PURE__*/React.createElement(SoundSourceDebugUI, null)), /*#__PURE__*/React.createElement(Section, {
    style: {
      flexBasis: "200px"
    }
  }, /*#__PURE__*/React.createElement(SoundInstanceDebugUI, null))));
};